// Ask for browser permission
export async function requestNotificationPermission() {
  if (!("Notification" in window)) {
    alert("This browser does not support notifications.");
    return;
  }

  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    console.log("✅ Notification permission granted!");
  } else {
    console.log("🚫 Notification permission denied.");
  }
}

// Register service worker and subscribe user
export async function registerServiceWorkerAndSubscribe() {
  if (!("serviceWorker" in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register("/service-worker.js");
    console.log("✅ Service Worker registered:", registration);

    const vapidPublicKey = "BOkpC9xOIOHyRSGBysb53Sp4-YQH3DnHDFNdsmV1bZgJRSMBJEjvOTrmYk2bA9qRk9HD-R0Te0BfGeeT25KMiDE";
    const convertedKey = urlBase64ToUint8Array(vapidPublicKey);

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedKey,
    });

    console.log("📬 Push Subscription:", subscription);

    // Send to backend
    await fetch("http://localhost:4000/subscribe", {
      method: "POST",
      body: JSON.stringify(subscription),
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("❌ Error during push setup:", error);
  }
}

// Helper function
function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
